// From Iconoir — used via Iconify (https://iconify.design)
import type { SVGProps } from "react";

export function CpuIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M8 15.4V8.6a.6.6 0 0 1 .6-.6h6.8a.6.6 0 0 1 .6.6v6.8a.6.6 0 0 1-.6.6H8.6a.6.6 0 0 1-.6-.6"/><path d="M8.5 3v2.5M15.5 3v2.5M20.5 8.5H18M20.5 15.5H18M15.5 20.5V18M8.5 20.5V18M3.5 15.5H6M3.5 8.5H6"/><path d="M6 18H4.6a.6.6 0 0 1-.6-.6V16m14 2h1.4a.6.6 0 0 0 .6-.6V16M18 6h1.4a.6.6 0 0 1 .6.6V8M6 6H4.6a.6.6 0 0 0-.6.6V8"/></g>
    </svg>
  );
}
